// @ts-nocheck
import React from 'react';
import { ArrowRightIcon } from './icons';

const PrimaryButton = ({
  children, type = 'submit', disabled, loading, withArrow = true,
}) => (
  <button type={type} disabled={disabled || loading} className="submit">
    <span>{loading ? 'Signing in…' : children}</span>
    {withArrow && !loading && <ArrowRightIcon />}
  </button>
);

export default PrimaryButton;
